module.exports = __webpack_public_path__ + "static/media/recruitment3.ccdafa04.jpg";